var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('v-card',{attrs:{"flat":""}},[_c('Table',{attrs:{"items":_vm.data.associates},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('thead',[_c('tr',[_c('th',[_vm._v("Pay In/Out")]),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.data.balance)))])])])]},proxy:true}],null,false,1682271247)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }